// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U8ijQ","rootMobile":"styles_rootMobile__3NJRe"};